<template>
  <div class="hello">
    <input v-model="barcode" type="password" ref="barcode">
      <input v-model="barcode" type="text" @focus="handleFocus">
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
     barcode: ""
    }
  },
  methods: {
		handleFocus() {
			this.$refs.barcode.select();
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/scantest.vue